import { fromJS } from 'immutable';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';

export const SET_SNAP_POINTS = 'SET_SNAP_POINTS';
export const CLEAR_SNAP_POINTS = 'CLEAR_SNAP_POINTS';

const initialState = fromJS({
  xSnapPoints: [],
  ySnapPoints: [],
});

/**
 * Reducers
 */

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SNAP_POINTS:
      let withX = state.set('xSnapPoints', fromJS(action.xPoints));
      let withY = withX.set('ySnapPoints', fromJS(action.yPoints));
      return withY;
    case CLEAR_SNAP_POINTS:
      return fromJS({
        xSnapPoints: [],
        ySnapPoints: [],
      });
  }

  return state;
};

/**
 * actions
 */

export function setSnapPoints(xPoints, yPoints) {
  return {
    type: SET_SNAP_POINTS,
    xPoints,
    yPoints,
  };
}

export function clearSnapPoints() {
  return {
    type: CLEAR_SNAP_POINTS,
  };
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
};
